export const flutterAssetPaths = {
  logo: "/assets/common/logos/S-Alpha_logo.png",
  logoSmall: "/assets/common/logos/S-Alpha_small_logo.png",
  satySprite: "/assets/common/saty_sprite@3x.png",
  satySpriteDarkGreen: "/assets/common/saty_sprite_dark_green@3x.png",
  icon: {
    calendar: "/assets/icon/calender.svg",
    cancel: "/assets/icon/cancel.svg",
    dashboard: "/assets/icon/dashboard.svg",
    doctorList: "/assets/icon/doctor_list.svg",
    hospitalList: "/assets/icon/hospital_list.svg",
    lightMode: "/assets/icon/light-mode.png",
    logPage: "/assets/icon/log_page.svg",
    nightMode: "/assets/icon/night-mode.png",
    patientList: "/assets/icon/patient_list.svg",
  },
} as const;

export type FlutterAssetIconName = keyof typeof flutterAssetPaths.icon;
